module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('subscription-id-and-client')) ? _c('div', {
    staticClass: "field-subscription-id-and-client"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.client.name) + " " + _vm._s(_vm.item.client.surname))])]) : (_vm.$is('plan-name')) ? _c('div', {
    staticClass: "field-plan-name"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.plan.name))])]) : (_vm.$is('subscription-booking-mode')) ? _c('div', {
    staticClass: "field-subscription-booking-mode iconized"
  }, [_c('i', {
    staticClass: "pm-icon subs-bookingtype"
  }), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.plan.booking_mode))])]) : (_vm.$is('subscription-max-drivers')) ? _c('div', {
    staticClass: "field-subscription-max-drivers iconized"
  }, [_c('i', {
    staticClass: "pm-icon subs-drivers"
  }), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.drivers.length) + "/" + _vm._s(_vm.item.plan.max_drivers))])]) : (_vm.$is('subscription-expire-in')) ? _c('div', {
    staticClass: "field-expire-in"
  }, [(_vm.item.start && _vm.item.end) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("EXPIRE IN: " + _vm._s(_vm.item.start) + " " + _vm._s(_vm.item.end) + " " + _vm._s(_vm.$diffInDays(_vm.item.end, _vm.item.start)) + " days")]) : _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Unactive subscription")])]) : (_vm.$is('plan-billing-cycle')) ? _c('div', {
    staticClass: "field-plan-billing-cycle iconized"
  }, [_vm._m(0), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("*/" + _vm._s(_vm.item.plan.billing_cycle) + " days")])]) : (_vm.$is('renew-info')) ? _c('div', {
    staticClass: "field-auto-renew iconized"
  }, [_c('i', {
    staticClass: "pm-icon subs-expiry",
    style: ({
      color: _vm.item.auto_renew == '1' ? 'green' : 'red'
    })
  }), (_vm.item.auto_renew == '1' && (_vm.item.start && _vm.item.end)) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$diffInDays(_vm.item.start, _vm.item.end) - 1) + " days")]) : _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Unactive/Disabled")])]) : (_vm.$is('plan-cost-billing-cycle')) ? _c('div', {
    staticClass: "field-plan-cost-billing-cycle"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('strong', [_vm._v(_vm._s(_vm.item.plan.cost) + _vm._s(_vm.currency) + "/" + _vm._s(_vm.$daysNumberToHuman(_vm.item.plan.billing_cycle)))])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-value"
  }, [_c('i', {
    staticClass: "pm-icon subs-billing"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-112488ec!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/SubscriptionFields.vue
// module id = 2260
// module chunks = 1